import { Routes } from '@angular/router';

export const routes: Routes = [
  {
    path: '',
    loadComponent: () => import('pages/home/home.page').then(m => m.HomePage)
  },
  {
    path: '',
    loadComponent: () =>
      import('./components/default-page-layout/default-page-layout.component').then(m => m.DefaultPageLayoutComponent),
    children: [
      {
        path: 'calendar',
        loadChildren: () => import('./calendar.routes').then(m => m.calendarRoutes)
      },
      {
        path: 'about',
        loadComponent: () => import('pages/about/about.page').then(m => m.AboutPage)
      },
      {
        path: 'contact',
        loadComponent: () => import('pages/contact/contact.page').then(m => m.ContactPage)
      }
    ]
  }
];
